import { createSelector } from 'reselect'

const getGeneralSettings = state => state.generalSettings;

export const getPageIsLoadingData = createSelector(
  getGeneralSettings,
  (generalSettings) => {
    return generalSettings.pageIsLoadingData;
  }
);